import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { invalidateCandidateAvatarQueries } from "./invalidateCandidateAvatarQueries";

interface CandidateWithUuid {
  uuid: string;
}

interface MutateCandidateImageVariables {
  candidate: CandidateWithUuid;
  image: File;
}

export default function useMutateCandidateImage() {
  const client = useQueryClient();
  const axios = useAxios();

  return {
    mutation: useMutation({
      mutationFn: ({ candidate, image }: MutateCandidateImageVariables) => {
        const formData = new FormData();
        formData.append("image", image);
        return axios.post(`/candidate/${candidate.uuid}/image`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      },
      onSuccess: (data, variables) => {
        client.setQueryData(
          ["candidateDetails", variables.candidate.uuid],
          data
        );
        return invalidateCandidateAvatarQueries(client);
      },
    }),
  };
}
